module.exports = __webpack_public_path__ + "img/5.d6ded04c.png";